import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import momentTz from 'moment-timezone';
import Box from '@mui/material/Box';
import SvgIcon from '@mui/material/SvgIcon';
import { Moment } from 'moment';
import { BaseLabel } from '@mgm/common/components/base';
import { TBreak } from '../types';
import { InputTimePicker } from './pickers';
import { ReactComponent as TrashIcon } from '../static/icons/ic_trash.svg';

type TBreaksCard = {
  breaks: Array<TBreak>
  startTime: Moment | null
  endTime: Moment | null
  addBreak: VoidFunction
  deleteBreak: (id?: number) => void
  setBreakTime: (time: Moment | null, field: string, breakIndex: number) => void
};

const BreaksCard: FC<TBreaksCard> = ({
  breaks,
  startTime,
  endTime,
  addBreak,
  deleteBreak,
  setBreakTime,
}) => {
  const { t } = useTranslation(['timesheets', 'schedule']);

  return (
    <>
      <Grid
        size={{
          xs: 12,
          sm: 12,
          md: 12,
          lg: 12,
        }}
      >
        <Typography variant="subtitle1">{t('designatedBreaks', { ns: 'schedule' })}</Typography>
      </Grid>
      <Grid
        paddingLeft={1}
        size={{
          xs: 12,
          sm: 12,
          md: 12,
          lg: 12,
        }}
      >
        <Button
          id="add-break"
          disabled={breaks?.length > 2 || !startTime || !endTime}
          onClick={addBreak}
        >
          +
          {' '}
          {t('addBreak')}
        </Button>
      </Grid>
      { breaks?.map((item, index) => (
        <Fragment key={`${item.id}-${index?.toString()}`}>
          <Grid size={{
            xs: 5,
            sm: 5,
            md: 5,
            lg: 5,
          }}
          >
            <BaseLabel letterSpacing="-0.5px">{t('breakStart')}</BaseLabel>
            <InputTimePicker
              isRequired={false}
              name={`start-${index}`}
              minTime={index === 0 ? startTime
                : momentTz(breaks[index - 1]?.breakEnd)}
              maxTime={endTime}
              defaultValue={momentTz(item.breakStart)}
              onChange={(time) => setBreakTime(time, 'breakStart', index)}
              placeholder={t('startTime')}
            />
          </Grid>
          <Grid size={{
            xs: 5,
            sm: 5,
            md: 5,
            lg: 5,
          }}
          >
            <BaseLabel letterSpacing="-0.5px">{t('breakEnd')}</BaseLabel>
            <InputTimePicker
              isRequired={false}
              name={`end-${index}`}
              defaultValue={momentTz(item.breakEnd)}
              minTime={momentTz(item.breakStart)}
              maxTime={endTime}
              onChange={(time) => setBreakTime(time, 'breakEnd', index)}
              placeholder={t('breakTime')}
            />
          </Grid>
          <Grid
            justifyContent="flex-end"
            display="flex"
            size={{
              xs: 2,
              sm: 2,
              md: 2,
              lg: 2,
            }}
          >
            <Box pt={3} onClick={() => deleteBreak(item?.id)}>
              <SvgIcon className="cursor-pointer" component={TrashIcon} inheritViewBox />
            </Box>
          </Grid>
        </Fragment>
      )) }
    </>
  );
};

export {
  BreaksCard,
};
